"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.isProducer = void 0;
var hasOwnProperty = function (obj, prop) {
    return obj.hasOwnProperty(prop);
};
var isProducer = function (x) {
    if (x &&
        typeof x === "object" &&
        hasOwnProperty(x, "type") &&
        typeof x.type === "string" &&
        x.type === "producer") {
        return true;
    }
    else {
        return false;
    }
};
exports.isProducer = isProducer;
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiaXNQcm9kdWNlci5qcyIsInNvdXJjZVJvb3QiOiIiLCJzb3VyY2VzIjpbIi4uL3NyYy9pc1Byb2R1Y2VyLnRzIl0sIm5hbWVzIjpbXSwibWFwcGluZ3MiOiI7OztBQUFBLElBQU0sY0FBYyxHQUFHLFVBQ3JCLEdBQU0sRUFDTixJQUFPO0lBRVAsT0FBTyxHQUFHLENBQUMsY0FBYyxDQUFDLElBQUksQ0FBQyxDQUFDO0FBQ2xDLENBQUMsQ0FBQztBQUVLLElBQU0sVUFBVSxHQUFHLFVBQUMsQ0FBVTtJQUNuQyxJQUNFLENBQUM7UUFDRCxPQUFPLENBQUMsS0FBSyxRQUFRO1FBQ3JCLGNBQWMsQ0FBQyxDQUFDLEVBQUUsTUFBTSxDQUFDO1FBQ3pCLE9BQU8sQ0FBQyxDQUFDLElBQUksS0FBSyxRQUFRO1FBQzFCLENBQUMsQ0FBQyxJQUFJLEtBQUssVUFBVSxFQUNyQjtRQUNBLE9BQU8sSUFBSSxDQUFDO0tBQ2I7U0FBTTtRQUNMLE9BQU8sS0FBSyxDQUFDO0tBQ2Q7QUFDSCxDQUFDLENBQUM7QUFaVyxRQUFBLFVBQVUsY0FZckIifQ==